import { withTheme } from "@emotion/react";
import CITFormGroup from "../../../../Form/CITFormGroup";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Typography, Box, Stack, FormControlLabel, Checkbox, Grid, FormHelperText } from "@mui/material";
import TextInput from "../../../../Form/TextInput";
import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';



const Availabilty = (props) => {

    const certifiations = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']



    function TimeInput() {
        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker defaultValue={dayjs('2022-04-17T24:00')} 
                 sx={{

                    width:{xs:'inherit'},
                    '& .MuiOutlinedInput-notchedOutline':{
                       borderColor: '#98A2B3',
                       borderRadius:'8px',
                       paddingLeft:'24px',
                    },
                    ...theme.typography.textArea,
                    color:'#98A2B3'
                 }}
                />
            </LocalizationProvider>

        );
    }



    const theme = props.theme

    const Header = (props) => {

        return (<Box mt={props.mt ?? 0} width={'100%'}>
            <Stack width={'100%'} direction={'row'}>
                <FormHelperText sx={{ ...theme.typography.inputTitle, color: '#292727', mb: '16px',mr:{xs:'86px', sm:'108px' } }} >{'Days'}</FormHelperText>
                <FormHelperText sx={{ ...theme.typography.inputTitle, color: '#292727', mb: '16px',mr:{xs:'36px', sm:'390px'} }}>{'From(Time)'}</FormHelperText>
                <FormHelperText sx={{ ...theme.typography.inputTitle, color: '#292727', mb: '16px' }} >{'To(Time)'}</FormHelperText>
            </Stack>
        </Box>
        )
    }

    const AvailableTimes = () => {

        return (

            <Box mt={'0px !important'} width={'100%'}>
                <Grid container rowSpacing={'16px'} columnSpacing={{xs:'0px',sm:'48px'}} >
                    {certifiations.map((cert ) => (
                        <Grid key={cert} item xs={12} sm={12} md={12} >
                            <Stack spacing={{xs:'24px',sm:'48px'}} width={'100%'} alignItems={'center'} direction={'row'}>
                                <FormControlLabel sx={{ width:{xs:'86px',sm:'80px'} }} control={<Checkbox />} label={<Typography color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'14px'} fontFamily={'inter'}>{cert}</Typography>} />
                                <TimeInput />
                                <TimeInput />
                            </Stack>
                        </Grid>
                    ))
                    }
                </Grid>
            </Box>
        )
    }

    return (

        <Box width={'inherit'}>
            <Stack mx={{ xs: '19px', sm: '60px', md: '85px' }} justifyContent={'space-around'} mt={'24px'} >
                <Typography width={{ sm: '668px', md: '998px' }} mb={'24px'} mt={'48px'} sx={{ ...theme.typography.heading, fontSize: { xs: '18px', sm: '20px', md: '29px' } }} gutterBottom>
                    {'AVAILABILITY & AREA OF TRAVEL'}
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                    {'What days are you available to work? Please indicate the days and hours you will be available to work.'}
                </Typography>
            </Stack>

            <CITFormGroup mt={'0px'} direction={'column'}>
                <Header mt={'35px !important'}  />
                <AvailableTimes />
                <TextInput mt='24px' textLable={'What is your area of travel?'} placeholder={'Your response'} boxWidth={'100%'} inputWidth={'inherit'} />
            </CITFormGroup>

        </Box>



    )
}

export default withTheme(Availabilty);